<template>
 <div class="task-card">
  <ul>
      <el-row>
        <el-col  v-for="(item,index) in liList" :key="index" :span="6">
            <li>
                <div>{{item.title | showNull}}</div>
                <div class="total">{{item.total | showNull}}</div>
                <div v-if="item.finishedAll" class="finished">总计：{{item.finishedAll | showNull}}</div>
                <div v-if="item.finished" class="finished">完成率：{{item.finished | showNull}}</div>
                <div v-if="item.delaied" class="finished">延期率：{{item.delaied | showNull}}</div>
            </li>
     </el-col>
      </el-row>
  </ul>
 </div>
</template>

<script>
export default {
  name: "task-card",
  props: {
    liList: Array
  },
  data() {
    return {};
  },
  filters: {
    showNull(val) {
      return val == null || val == undefined ? "-" : val;
    }
  }
};
</script>

<style scoped lang="scss">
.task-card {
  padding: 50px;
  background: white;
}
ul li {
  text-align: center;
}
ul li div:first-child {
  margin-bottom: 20px;
  font-size: 16px;
}
.finished {
  color: orange;
  font-size:18px;
  margin-top: 10px;
}
.total{
  font-size:16px;
  font-weight:600;
}
</style>
